import { EventEmitter } from '@angular/core';
import { RequestService, OriginatingSystem } from '../../shared/services/request.service';
import { BsModalService } from 'ngx-bootstrap';
import { AlertService } from '../../shared/services/alert.service';
import { TacticalLiaisonService } from '../../shared/services/tactical-liaison.service';
import { Observable } from 'rxjs';
import { AoiService } from '../../shared/services/aoi.service';
import { FacilityTypeService } from '../../shared/services/facility-type.service';
import { CreateExperimentModalComponent } from '../create-experiment-modal/create-experiment-modal.component';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize, mergeMap } from "rxjs/operators";
import { asEnumerable } from "linq-es2015";
import { FileSaverService } from '../../shared/services/file-saver.service';
import { RequestAssignmentModalComponent } from '../request-assignment-modal/request-assignment-modal.component';
import { RequestPlanningModalComponent } from '../request-planning-modal/request-planning-modal.component';
import { RequestReviewModalComponent } from '../request-review-modal/request-review-modal.component';
import { RequestStatusEnum } from '../../shared/services/request-status.service';
import { RequestRejectionModalComponent } from '../request-rejection-modal/request-rejection-modal.component';
import { Router } from '@angular/router';
import { ConfirmationModalComponent } from '../../shared/components/confirmation-modal/confirmation-modal.component';
import { UserRoles } from '../../shared/services/current-user.service';
import { RequestCommentsService } from '../../shared/services/request-comments.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { PlanningService } from '../../shared/services/planning.service';
import { LaboratoryService } from '../../shared/services/laboratory.service';
import { GrowthStageService } from '../../shared/services/growth-stage.service';
import { TissueTypeService } from '../../shared/services/tissue-type.service';
import { map } from 'rxjs/operators';
import { RequestReAssignmentModalComponent } from '../request-reassignment-modal/request-reassignment-modal.component';
import { RequestTypeService } from '../../shared/services/request-type.service';
var RequestActionToolbarComponent = /** @class */ (function () {
    function RequestActionToolbarComponent(modalService, requestService, planningService, alertService, tacticalLiaisonService, aoiService, facilityTypeService, loadingService, fileSaverService, requestCommentsService, router, labService, growthStageService, tissueTypeService, requestTypeService, document) {
        this.modalService = modalService;
        this.requestService = requestService;
        this.planningService = planningService;
        this.alertService = alertService;
        this.tacticalLiaisonService = tacticalLiaisonService;
        this.aoiService = aoiService;
        this.facilityTypeService = facilityTypeService;
        this.loadingService = loadingService;
        this.fileSaverService = fileSaverService;
        this.requestCommentsService = requestCommentsService;
        this.router = router;
        this.labService = labService;
        this.growthStageService = growthStageService;
        this.tissueTypeService = tissueTypeService;
        this.requestTypeService = requestTypeService;
        this.document = document;
        this.statusChanged = new EventEmitter();
        this.saved = new EventEmitter();
        this.copyRoles = UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator;
        this.rejectRoles = UserRoles.CollaboratorLiaison;
        this.assignRoles = UserRoles.CollaboratorLiaison;
        this.planRoles = UserRoles.TacticalLiaison;
        this.reviewRoles = UserRoles.CollaboratorLiaison;
        this.createExperimentRoles = UserRoles.ExperimentCreator;
        this.exportEuidRoles = UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator;
        this.printPlantingCardRoles = UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator;
        this.cancelRoles = UserRoles.CollaboratorLiaison;
        this.reAssignRoles = UserRoles.CollaboratorLiaison;
        this.donorRequestRoles = UserRoles.TacticalLiaison;
        this.rejectButtonStatuses = [RequestStatusEnum.Submitted, RequestStatusEnum.Assigned, RequestStatusEnum.ReadyForReview];
        this.assignButtonStatuses = [RequestStatusEnum.Submitted];
        this.planButtonStatuses = [RequestStatusEnum.Assigned];
        this.reviewButtonStatuses = [RequestStatusEnum.ReadyForReview];
        this.createExperimentButtonStatuses = [RequestStatusEnum.Reviewed];
        this.exportButtonStatuses = [RequestStatusEnum.ExperimentInProgress, RequestStatusEnum.Pollination, RequestStatusEnum.Harvest, RequestStatusEnum.PlantedInFlat];
        this.printPlantingCardButtonStatuses = [RequestStatusEnum.ReadyForReview, RequestStatusEnum.Reviewed, RequestStatusEnum.CreatingExperiment, RequestStatusEnum.ExperimentInProgress, RequestStatusEnum.Pollination, RequestStatusEnum.Harvest, RequestStatusEnum.PlantedInFlat];
        this.cancelButtonStatuses = [RequestStatusEnum.Draft, RequestStatusEnum.Submitted, RequestStatusEnum.Assigned,
            RequestStatusEnum.ReadyForReview, RequestStatusEnum.Reviewed, RequestStatusEnum.CreatingExperiment, RequestStatusEnum.ExperimentInProgress,
            RequestStatusEnum.ExperimentCompleted, RequestStatusEnum.ExperimentCreationError];
        this.reAssignButtonStatuses = [RequestStatusEnum.Assigned, RequestStatusEnum.ReadyForReview, RequestStatusEnum.Reviewed];
    }
    Object.defineProperty(RequestActionToolbarComponent.prototype, "isTnRequest", {
        get: function () {
            return this.request.originatingSystem === OriginatingSystem.MyCE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RequestActionToolbarComponent.prototype, "isDonorNeeded", {
        get: function () {
            return (this.request.pollinationInstructions) ? this.request.pollinationInstructions.donorsNeeded : false;
        },
        enumerable: true,
        configurable: true
    });
    RequestActionToolbarComponent.prototype.ngOnInit = function () { };
    RequestActionToolbarComponent.prototype.showRejectionModal = function () {
        this.openRejectionModal();
    };
    RequestActionToolbarComponent.prototype.showAssignmentModal = function () {
        var _this = this;
        this.getActiveTacticalLiaisons()
            .subscribe(function (activeTacticalLiaisons) { return _this.openAssignmentModalWithLiaisons(activeTacticalLiaisons); });
    };
    RequestActionToolbarComponent.prototype.showReAssignmentModal = function () {
        var _this = this;
        forkJoin(this.getActiveTacticalLiaisons(), this.requestService.getCeLogistics(this.request.id))
            .subscribe(function (_a) {
            var tacticalLiaisons = _a[0], ceLogistics = _a[1];
            return _this.openReAssignmentModalWithLiaisons(tacticalLiaisons, ceLogistics.tacticalLiaisonId);
        });
    };
    RequestActionToolbarComponent.prototype.showPlanningModal = function () {
        var _this = this;
        Observable.forkJoin(this.planningService.getPlanningNotes(this.request.id), this.labService.getAll(), this.growthStageService.getAll(), this.tissueTypeService.getAll(), this.requestTypeService.getAll()).subscribe(function (_a) {
            var planningNotes = _a[0], labs = _a[1], growthStages = _a[2], tissueTypes = _a[3], requestTypes = _a[4];
            _this.openPlanningModalWithData(planningNotes, {
                labs: labs,
                growthStages: growthStages,
                tissueTypes: tissueTypes,
                requestTypes: requestTypes
            });
        });
    };
    RequestActionToolbarComponent.prototype.showReviewModal = function () {
        this.openReviewModal();
    };
    RequestActionToolbarComponent.prototype.showExperimentCreationModal = function () {
        var _this = this;
        this.loadingService.setMessage("Loading experiment creation options...");
        Observable.forkJoin(this.facilityTypeService.getAll(), this.aoiService.getAll(), this.requestService.getDetails(this.request.id), this.requestService.getCeLogistics(this.request.id), this.planningService.getPlanningNotes(this.request.id)).subscribe(function (_a) {
            var facilityTypes = _a[0], aois = _a[1], requestDetails = _a[2], ceLogistics = _a[3], planningNotes = _a[4];
            _this.loadingService.clearMessage();
            _this.openExperimentCreationModalWithData(facilityTypes, aois, requestDetails.cropId, ceLogistics, planningNotes);
        });
    };
    RequestActionToolbarComponent.prototype.printPlantingCard = function () {
        var _this = this;
        this.loadingService.setMessage("Printing Planting Card...");
        this.requestService.getPlantingCards([this.request.id])
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (plantingCardFile) {
            _this.fileSaverService.save(plantingCardFile);
            _this.alertService.success("Planting Card Download Complete!");
        }, function (errorResponse) {
            _this.alertService.error("Error retreiving Planting Card. " + errorResponse.error + ".");
        });
    };
    RequestActionToolbarComponent.prototype.cloneRequest = function () {
        this.openCloningConfirmationModal();
    };
    RequestActionToolbarComponent.prototype.createDonorRequest = function () {
        this.openDonorRequestConfirmationModal();
    };
    RequestActionToolbarComponent.prototype.exportEuids = function () {
        var _this = this;
        this.requestService.getPlantFile(this.request.id)
            .subscribe(function (f) {
            if (f) {
                _this.fileSaverService.save(f);
                _this.alertService.success('Exporting EUIDs complete!');
            }
            else {
                _this.alertService.error('Error exporting EUIDs');
            }
        }, function () { return _this.alertService.error('Error exporting EUIDs'); });
    };
    RequestActionToolbarComponent.prototype.cancelRequest = function () {
        this.openCancelConfirmationModal();
    };
    RequestActionToolbarComponent.prototype.getActiveTacticalLiaisons = function () {
        return this.tacticalLiaisonService.get()
            .pipe(map(function (tacticalLiaisons) {
            var liaisonList = asEnumerable(tacticalLiaisons || []);
            return liaisonList
                .Where(function (l) { return l.isActive; })
                .OrderBy(function (l) { return l.surname; })
                .ThenBy(function (l) { return l.givenName; })
                .ToArray();
        }));
    };
    RequestActionToolbarComponent.prototype.openRejectionModal = function () {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-lg',
            initialState: {
                request: this.request
            }
        };
        var modal = this.modalService.show(RequestRejectionModalComponent, modalOptions);
        var component = modal.content;
        component
            .onRejected
            .subscribe(function (comments) {
            _this.requestCommentsService.save(comments)
                .catch(function (e) {
                _this.alertService.error('Error saving notes');
                return Observable.throw(e);
            })
                .pipe(mergeMap(function () { return _this.requestService.rejectRequest(_this.request.id); }))
                .subscribe(function () {
                component.onRejected.unsubscribe();
                component.onBackToPlanning.unsubscribe();
                component.onClose.unsubscribe();
                modal.hide();
                _this.alertService.success('Rejected');
                _this.statusChanged.emit(null);
            }, function () { return _this.alertService.error('Error rejecting request...'); });
        });
        component
            .onBackToPlanning
            .subscribe(function (comments) {
            _this.requestCommentsService.save(comments)
                .catch(function (e) {
                _this.alertService.error('Error saving notes');
                return Observable.throw(e);
            })
                .pipe(mergeMap(function () { return _this.requestService.sendBackToPlanning(_this.request.id); }))
                .subscribe(function () {
                component.onRejected.unsubscribe();
                component.onBackToPlanning.unsubscribe();
                component.onClose.unsubscribe();
                modal.hide();
                _this.alertService.success('Sent back to planning');
                _this.statusChanged.emit(null);
            }, function () { return _this.alertService.error('Error sending back to planning...'); });
        });
        component
            .onClose
            .subscribe(function () {
            component.onRejected.unsubscribe();
            component.onBackToPlanning.unsubscribe();
            component.onClose.unsubscribe();
            modal.hide();
        });
    };
    RequestActionToolbarComponent.prototype.openAssignmentModalWithLiaisons = function (activeTacticalLiaisons) {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-lg',
            initialState: {
                request: this.request,
                tacticalLiaisons: activeTacticalLiaisons
            }
        };
        var modal = this.modalService.show(RequestAssignmentModalComponent, modalOptions);
        var component = modal.content;
        component
            .onAssigned
            .subscribe(function (assignmentWithComments) {
            _this.saveAssignmentsWithComments(modal, component, assignmentWithComments);
        });
        component
            .onClose
            .subscribe(function () {
            component.onAssigned.unsubscribe();
            component.onClose.unsubscribe();
            modal.hide();
        });
    };
    RequestActionToolbarComponent.prototype.saveAssignmentsWithComments = function (modal, component, assignmentWithComments) {
        var _this = this;
        var assignment = {
            tacticalLiaisonId: assignmentWithComments.tacticalLiaisonId,
            id: assignmentWithComments.id
        };
        var comments = {
            requestId: assignmentWithComments.id,
            comment: assignmentWithComments.comment,
            source: assignmentWithComments.source
        };
        forkJoin(this.requestCommentsService.save(comments)
            .catch(function (e) {
            _this.alertService.error('Error saving notes');
            return Observable.throw(e);
        }), this.requestService.saveAssignmentNotes(assignment)
            .catch(function (e) {
            _this.alertService.error('Error saving assignment details');
            return Observable.throw(e);
        })).subscribe(function () {
            _this.requestService.assignRequest(assignmentWithComments.id)
                .subscribe(function () {
                component.onAssigned.unsubscribe();
                component.onClose.unsubscribe();
                modal.hide();
                _this.alertService.success('Assigned!');
                _this.statusChanged.emit(null);
            }, function () {
                _this.alertService.error('Failed to set status to assigned. Please contact support');
            });
        });
    };
    RequestActionToolbarComponent.prototype.openReAssignmentModalWithLiaisons = function (activeTacticalLiaisons, initialTacticalLiaisonId) {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-lg',
            initialState: {
                request: this.request,
                tacticalLiaisons: activeTacticalLiaisons,
                initialTacticalLiaisonId: initialTacticalLiaisonId
            }
        };
        var modal = this.modalService.show(RequestReAssignmentModalComponent, modalOptions);
        var component = modal.content;
        component
            .onReAssigned
            .subscribe(function (reAassignment) {
            _this.reAssignRequest(modal, component, reAassignment.requestId, reAassignment.tacticalLiaisonId);
        });
        component
            .onClose
            .subscribe(function () {
            component.onReAssigned.unsubscribe();
            component.onClose.unsubscribe();
            modal.hide();
        });
    };
    RequestActionToolbarComponent.prototype.reAssignRequest = function (modal, component, requestId, tacticalLiaisonUserId) {
        var _this = this;
        this.requestService.reAssignRequest(requestId, tacticalLiaisonUserId).subscribe(function () {
            component.onReAssigned.unsubscribe();
            component.onClose.unsubscribe();
            modal.hide();
            _this.alertService.success('Re-assigned!');
            _this.statusChanged.emit(null);
        }, function (error) {
            _this.alertService.error("Error re-assigning Tactial Liaison to Request. Please contact support");
            console.log(error);
        });
    };
    RequestActionToolbarComponent.prototype.openPlanningModalWithData = function (savedData, options) {
        var _this = this;
        var availableRequestTypes = asEnumerable(options.requestTypes || []);
        var activeRequestTypes = availableRequestTypes
            .Where(function (a) { return a.isActive; })
            .OrderBy(function (a) { return a.order; })
            .ToArray();
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'custom-modal-lg',
            initialState: {
                request: this.request,
                isWheatRequest: this.isWheatRequest,
                labs: asEnumerable(options.labs),
                growthStages: asEnumerable(options.growthStages),
                tissueTypes: asEnumerable(options.tissueTypes),
                planningInformation: savedData,
                requestTypes: activeRequestTypes
            }
        };
        var modalInstance = this.modalService.show(RequestPlanningModalComponent, modalOptions);
        var component = modalInstance.content;
        component.onSave
            .subscribe(function (n) {
            _this.planningService
                .savePlanningNotes(n)
                .subscribe(function () {
                _this.alertService.success('Saved request planning notes...');
                _this.saved.emit(null);
            }, function () { return _this.alertService.error('Error saving request planning notes...'); });
        });
        component.onPlanned
            .subscribe(function (n) {
            _this.planningService
                .savePlanningNotes(n)
                .switchMap(function (d) { return _this.requestService.completeRequestPlan(_this.request.id); })
                .subscribe(function () {
                component.onSave.unsubscribe();
                component.onPlanned.unsubscribe();
                component.onClose.unsubscribe();
                modalInstance.hide();
                _this.alertService.success('Request plan complete!');
                _this.statusChanged.emit(null);
            }, function () { return _this.alertService.error('Error completing request plan'); });
        });
        component.onClose
            .subscribe(function () {
            component.onSave.unsubscribe();
            component.onPlanned.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
    };
    RequestActionToolbarComponent.prototype.openReviewModal = function () {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-lg',
            initialState: {
                request: this.request
            }
        };
        var modal = this.modalService.show(RequestReviewModalComponent, modalOptions);
        var component = modal.content;
        component
            .onReviewed
            .subscribe(function (comments) {
            _this.requestCommentsService.save(comments)
                .catch((function (e) {
                _this.alertService.error('Error saving notes');
                return Observable.throw(e);
            }))
                .pipe(mergeMap(function () { return _this.requestService.completeRequestReview(_this.request.id); }))
                .subscribe(function () {
                component.onReviewed.unsubscribe();
                component.onClose.unsubscribe();
                modal.hide();
                _this.alertService.success('Review complete!');
                _this.statusChanged.emit(null);
            }, function () { return _this.alertService.error('Error completing review...'); });
        });
        component
            .onClose
            .subscribe(function () {
            component.onReviewed.unsubscribe();
            component.onClose.unsubscribe();
            modal.hide();
        });
    };
    RequestActionToolbarComponent.prototype.openExperimentCreationModalWithData = function (facilityTypes, aois, cropId, ceLogistics, planningNotes) {
        var _this = this;
        var availableFacilityTypes = asEnumerable(facilityTypes || []);
        var availableAois = asEnumerable(aois || []);
        var activeFacilityTypes = availableFacilityTypes
            .Where(function (f) { return f.isActive; })
            .OrderBy(function (f) { return f.order; })
            .ToArray();
        var activeAois = availableAois
            .Where(function (a) { return a.isActive; })
            .Where(function (a) { return a.cropId === cropId; })
            .OrderBy(function (a) { return a.name; })
            .ToArray();
        var initialState = {
            aois: activeAois,
            facilities: activeFacilityTypes,
            request: this.request,
            ceLogistics: ceLogistics,
            planningNotes: planningNotes
        };
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-lg',
            initialState: initialState
        };
        var modalInstance = this.modalService.show(CreateExperimentModalComponent, modalOptions);
        var component = modalInstance.content;
        component.onCreateExperiment
            .subscribe(function (experimentCreationDetails) {
            _this.loadingService.setMessage("Creating experiment...");
            _this.requestService.saveExperimentCreationDetails(experimentCreationDetails)
                .switchMap(function (d) { return _this.requestService.createExperiment(_this.request.id); })
                .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
                .subscribe(function () {
                component.onCreateExperiment.unsubscribe();
                component.onClose.unsubscribe();
                _this.alertService.success('Sent for experiment creation!');
                modalInstance.hide();
                _this.statusChanged.emit(null);
            }, function () { return _this.alertService.error('Error creating experiment'); });
        });
        component.onClose
            .subscribe(function () {
            component.onCreateExperiment.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
    };
    RequestActionToolbarComponent.prototype.openCloningConfirmationModal = function () {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: false,
            class: 'modal-md',
            initialState: {
                title: 'Please confirm',
                body: "Are you sure you want to copy request \"" + this.request.title + "\"?"
            }
        };
        var modalInstance = this.modalService.show(ConfirmationModalComponent, modalOptions);
        var component = modalInstance.content;
        component
            .onConfirm
            .subscribe(function () {
            modalInstance.hide();
            _this.loadingService.setMessage("Creating copy of " + _this.request.title);
            _this.requestService
                .cloneRequest(_this.request.id)
                .subscribe(function (r) {
                component.onConfirm.unsubscribe();
                component.onCancel.unsubscribe();
                component.onClose.unsubscribe();
                modalInstance.hide();
                _this.router.navigate(["/requests/edit/" + r.id]);
            }, function (e) {
                _this.loadingService.clearMessage();
                _this.alertService.error("Error copying request " + _this.request.title);
            });
        });
        component
            .onCancel
            .subscribe(function () {
            component.onConfirm.unsubscribe();
            component.onCancel.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
        component
            .onClose
            .subscribe(function () {
            component.onConfirm.unsubscribe();
            component.onCancel.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
    };
    RequestActionToolbarComponent.prototype.openDonorRequestConfirmationModal = function () {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: false,
            class: 'modal-md',
            initialState: {
                title: 'Please confirm',
                body: "Are you sure you want to create a donor request for \"" + this.request.title + "\"?"
            }
        };
        var modalInstance = this.modalService.show(ConfirmationModalComponent, modalOptions);
        var component = modalInstance.content;
        component
            .onConfirm
            .subscribe(function () {
            modalInstance.hide();
            _this.loadingService.setMessage("Creating donor request for " + _this.request.title);
            _this.requestService
                .createDonorRequest(_this.request.id)
                .subscribe(function (r) {
                component.onConfirm.unsubscribe();
                component.onCancel.unsubscribe();
                component.onClose.unsubscribe();
                modalInstance.hide();
                var baseHref = _this.document.querySelector('base').getAttribute('href');
                if (!baseHref.startsWith('/')) {
                    baseHref = '/' + baseHref;
                }
                baseHref = baseHref.replace(/\/$/, '');
                var tree = _this.router.createUrlTree(["/requests/edit/" + r.id]);
                var relativeUrl = _this.router.serializeUrl(tree);
                relativeUrl = relativeUrl.replace(/^\/+/, '');
                var url = "" + window.location.origin + baseHref + "/" + relativeUrl;
                window.open(url, '_blank');
                _this.loadingService.clearMessage();
            }, function (e) {
                _this.loadingService.clearMessage();
                _this.alertService.error("Error creating donor request for " + _this.request.title);
            });
        });
        component
            .onCancel
            .subscribe(function () {
            component.onConfirm.unsubscribe();
            component.onCancel.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
        component
            .onClose
            .subscribe(function () {
            component.onConfirm.unsubscribe();
            component.onCancel.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
    };
    RequestActionToolbarComponent.prototype.openCancelConfirmationModal = function () {
        var _this = this;
        var modalOptions = {
            backdrop: true,
            ignoreBackdropClick: false,
            class: 'modal-md',
            initialState: {
                title: 'Please confirm',
                body: "Are you sure you want to cancel request \"" + this.request.title + "\"?"
            }
        };
        var modalInstance = this.modalService.show(ConfirmationModalComponent, modalOptions);
        var component = modalInstance.content;
        component
            .onConfirm
            .subscribe(function () {
            modalInstance.hide();
            _this.loadingService.setMessage("Cancelling request " + _this.request.title);
            _this.requestService
                .cancelRequest(_this.request.id)
                .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
                .subscribe(function (r) {
                component.onConfirm.unsubscribe();
                component.onCancel.unsubscribe();
                component.onClose.unsubscribe();
                _this.alertService.success("Request " + _this.request.title + " has been cancelled");
                _this.statusChanged.emit(null);
            }, function (e) {
                _this.alertService.error("Error cancelling request " + _this.request.title);
            });
        });
        component
            .onCancel
            .subscribe(function () {
            component.onConfirm.unsubscribe();
            component.onCancel.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
        component
            .onClose
            .subscribe(function () {
            component.onConfirm.unsubscribe();
            component.onCancel.unsubscribe();
            component.onClose.unsubscribe();
            modalInstance.hide();
        });
    };
    return RequestActionToolbarComponent;
}());
export { RequestActionToolbarComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-action-toolbar/request-action-toolbar.component.ts.pre-build-optimizer.js